import React from "react";
import PrimaryButton from "../PrimaryButton/PrimaryButton";
import { IconPlus } from "@tabler/icons-react";
import { PATHS } from "../../constants/paths";
import { Group } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import AddPatient from "../Receptionist/Add Patient/AddPatient";
import AddAppointment from "../Receptionist/Add Appointment/AddAppointment";

const Receptionist = () => {
  const navigate = useNavigate();
  return (
    <Group>
      <AddPatient />
      <AddAppointment />
    </Group>
  );
};

const Pharmacist = () => {
  const navigate = useNavigate();
  return (
    <PrimaryButton
      text="Create OTC Invoice"
      leftSection={<IconPlus size={18} />}
      onClick={() => navigate(PATHS.PHARMACIST_CREATE_OTC_INVOICE)}
    />
  );
};

export default function Components({ role }) {
  switch (role) {
    case "receptionist":
      return <Receptionist />;
    case "pharmacist":
      return <Pharmacist />;
    default:
      return null;
  }
}
